var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.563 11.625a.438.438 0 11-.876 0 .438.438 0 01.875 0zm0 0h-.438m4.813 0a.438.438 0 11-.876 0 .438.438 0 01.876 0zm0 0H12.5m4.813 0a.438.438 0 11-.876 0 .438.438 0 01.875 0zm0 0h-.438m6.125 0c0 5.315-4.702 9.625-10.5 9.625a11.392 11.392 0 01-2.98-.393 6.967 6.967 0 01-5.261 1.157 5.227 5.227 0 001.14-2.362c.106-.534-.154-1.052-.544-1.43C3.085 16.498 2 14.178 2 11.624 2 6.31 6.702 2 12.5 2S23 6.31 23 11.625z"
  })));
}
export default SvgRoomChatIcon;